import { FT5_EVENT_TRACKING } from '../../../constants';
import { DataContainer, submitEvent } from '@otto-ec/tracking-bct';
import { getProductFeaturesForNonPdpPage } from '../../../_common/client/tracking/get-product-features-for-non-pdp-page';

export function registerEventTracking(variationData: { productId: string; variationId: string; moin: string }) {
    o_global.eventQBus.on(FT5_EVENT_TRACKING, (trackingData: DataContainer) => {
        submitEvent(trackingData, {
            name: 'click',
            features: getProductFeaturesForNonPdpPage(variationData),
        });
    });
}
